

export function pushToDataLayer(payload) {
  if (typeof window === "undefined") return; // SSR safety
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}
